export const getGstBreakup = (totalGstAmount, sellerState, buyerState) => {
    const total = Number(totalGstAmount) || 0;
    const seller = parseInt(sellerState);
    const buyer = parseInt(buyerState);

    console.log("buyer",buyer);
    console.log("seller",sellerState);

    // 1. If buyerState is missing, assume Intra-State (Local) as a placeholder
    // or return an empty array if you don't want to show taxes yet.
    if (!buyerState) {
        const half = (total / 2).toFixed(2);
        return [
            { label: 'CGST (Prov)', amount: half },
            { label: 'SGST (Prov)', amount: half }
        ];
    }

    const UGST_CODES = [4, 25, 26, 31, 35, 38, 97];

    if (seller !== buyer) {
        return [{ label: 'IGST', amount: total.toFixed(2) }];
    } else {
        const half = (total / 2).toFixed(2);
        const isUT = UGST_CODES.includes(seller);
        return [
            { label: 'CGST', amount: half },
            { label: isUT ? 'UGST' : 'SGST', amount: half }
        ];
    }
};